// extracted by mini-css-extract-plugin
export default {"container":"coin-info_container__h-cjU","loader":"coin-info_loader__uBdz8","buttonWrapper":"coin-info_buttonWrapper__FVZKf"};